import { StyleSheet, TouchableOpacity, View } from "react-native";
import CustomText from "../../../components/common/general/CustomText/CustomText";
import { Course, useRemovePreRequisitesFromCourseMutation } from "../../../graphql/generated/graphql";
import { X } from "@phosphor-icons/react";

const CoursePreRequisitePill = ({
  courseId,
  prerequisite,
  refetchCourse,
}: {
  courseId: string;
  prerequisite: Course;
  refetchCourse: () => void;
}) => {
  const [removePrerequisite] = useRemovePreRequisitesFromCourseMutation();

  const handleRemovePrerequisite = async (prerequisiteId: string) => {
    const { data: removePrerequisiteData } = await removePrerequisite({
      variables: {
        courseId: courseId,
        preRequisiteIds: [prerequisiteId],
      },
    });

    refetchCourse();
  };
  return (
    <View key={prerequisite.id} style={styles.preReqPill}>
      <CustomText text={prerequisite.name} size="s" weight="medium" styleType="light" useTranslationText={false} />
      <TouchableOpacity onPress={() => handleRemovePrerequisite(prerequisite.id)}>
        <X size={16} weight="bold" color={"#FFFFFF"} />
      </TouchableOpacity>
    </View>
  );
};

export default CoursePreRequisitePill;

const styles = StyleSheet.create({
  preReqPill: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    backgroundColor: "#3E68FE",
    color: "#FFFFFF",
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 100,
  },
});
